<p-toast/>

<div class="flex flex-col gap-4 w-full">

  <!-- Cabeçalho -->
  <p-card>
    <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-center gap-3">
        <i class="pi pi-list text-2xl text-[#E41B2E]"></i>
        <span class="header-title-table">Gerenciar Listas</span>
      </div>
      <a routerLink="/admin"
         class="text-sm text-gray-500 dark:text-red-500 hover:text-[#E41B2E] dark:hover:text-red-400
                flex items-center gap-1 transition-colors self-start sm:self-auto">
        <i class="pi pi-arrow-left text-xs"></i> Voltar ao painel
      </a>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      Adicione ou remova valores das listas suspensas usadas nas notificações.
      Itens em uso por notificações não podem ser removidos.
    </p>
  </p-card>

  <!-- Grid de cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

    @for (tipo of tipos; track tipo.tipo) {
      <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 flex flex-col">

        <!-- Header do card -->
        <div class="flex items-center gap-2 px-4 pt-4 pb-3 border-b border-gray-100 dark:border-zinc-800">
          <i [class]="'pi ' + tipo.icon + ' text-[#E41B2E]'"></i>
          <span class="font-semibold text-gray-800 dark:text-white">{{ tipo.label }}</span>
          @if (!loadingMap[tipo.tipo]) {
            <span class="ml-auto text-xs text-gray-400 bg-gray-100 dark:bg-zinc-800 dark:text-zinc-400 px-2 py-0.5 rounded-full">
              {{ items[tipo.tipo].length }}
            </span>
          }
        </div>

        <!-- Lista de valores -->
        <div class="overflow-y-auto max-h-56 px-2 py-2 space-y-0.5 flex-1">
          @if (loadingMap[tipo.tipo]) {
            @for (i of [1,2,3,4]; track i) {
              <div class="px-2 py-2">
                <p-skeleton height="0.875rem" [width]="i % 2 === 0 ? '60%' : '80%'"/>
              </div>
            }
          } @else if (items[tipo.tipo].length === 0) {
            <p class="text-xs text-gray-400 dark:text-zinc-500 text-center py-6 italic">
              Nenhum item cadastrado
            </p>
          } @else {
            @for (item of items[tipo.tipo]; track item.id) {
              <div class="flex items-center rounded px-2 py-1.5 group hover:bg-gray-50 dark:hover:bg-zinc-900 transition-colors min-h-[32px]">
                @if (isConfirmando(tipo.tipo, item.id)) {
                  <span class="text-xs text-red-600 dark:text-red-400 font-medium flex-1 truncate">
                    Confirmar exclusão?
                  </span>
                  <div class="flex gap-1 flex-shrink-0 ml-2">
                    <button (click)="confirmarExclusao()"
                            class="text-[11px] font-medium text-white bg-red-600 hover:bg-red-700 px-2 py-0.5 rounded transition-colors">
                      Excluir
                    </button>
                    <button (click)="cancelarExclusao()"
                            class="text-[11px] text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-700 px-2 py-0.5 rounded transition-colors">
                      Cancelar
                    </button>
                  </div>
                } @else {
                  <span class="text-sm text-gray-700 dark:text-gray-300 flex-1 truncate" [title]="item.nome">{{ item.nome }}</span>
                  <button (click)="solicitarExclusao(tipo.tipo, item.id)"
                          title="Remover este item"
                          class="opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 ml-2
                                 text-gray-300 hover:text-red-500 dark:text-zinc-600 dark:hover:text-red-400 p-0.5 rounded">
                    <i class="pi pi-trash text-xs"></i>
                  </button>
                }
              </div>
            }
          }
        </div>

        <!-- Formulário de adição -->
        <div class="px-3 pb-3 pt-2 border-t border-gray-100 dark:border-zinc-800">
          @if (tipo.isConcessionaria) {
            <!-- Concessionária: dois campos (Lote + Nome Amigável) -->
            <div class="flex flex-col gap-1.5">
              <div class="flex gap-1.5">
                <input type="text"
                       [(ngModel)]="novoLote[tipo.tipo]"
                       placeholder="Lote (ex: 01)"
                       class="w-20 flex-shrink-0 text-xs border border-gray-300 dark:border-zinc-600 rounded
                              px-2 py-1.5 bg-white dark:bg-zinc-900 text-gray-700 dark:text-gray-200
                              placeholder:text-gray-400 dark:placeholder:text-zinc-500
                              focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400 transition-colors"/>
                <input type="text"
                       [(ngModel)]="novoNome[tipo.tipo]"
                       (keyup.enter)="criar(tipo)"
                       placeholder="Nome amigável..."
                       class="flex-1 min-w-0 text-xs border border-gray-300 dark:border-zinc-600 rounded
                              px-2 py-1.5 bg-white dark:bg-zinc-900 text-gray-700 dark:text-gray-200
                              placeholder:text-gray-400 dark:placeholder:text-zinc-500
                              focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400 transition-colors"/>
                <button (click)="criar(tipo)"
                        [disabled]="!podeAdicionar(tipo)"
                        title="Adicionar concessionária"
                        class="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded
                               bg-[#E41B2E] hover:bg-red-700 text-white transition-colors
                               disabled:opacity-40 disabled:cursor-not-allowed self-end">
                  @if (savingMap[tipo.tipo]) {
                    <i class="pi pi-spin pi-spinner text-xs"></i>
                  } @else {
                    <i class="pi pi-plus text-xs"></i>
                  }
                </button>
              </div>
            </div>
          } @else {
            <!-- Campos simples: apenas nome -->
            <div class="flex gap-1.5">
              <input type="text"
                     [(ngModel)]="novoNome[tipo.tipo]"
                     (keyup.enter)="criar(tipo)"
                     placeholder="Novo item..."
                     class="flex-1 min-w-0 text-xs border border-gray-300 dark:border-zinc-600 rounded
                            px-2 py-1.5 bg-white dark:bg-zinc-900 text-gray-700 dark:text-gray-200
                            placeholder:text-gray-400 dark:placeholder:text-zinc-500
                            focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400 transition-colors"/>
              <button (click)="criar(tipo)"
                      [disabled]="!podeAdicionar(tipo)"
                      title="Adicionar"
                      class="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded
                             bg-[#E41B2E] hover:bg-red-700 text-white transition-colors
                             disabled:opacity-40 disabled:cursor-not-allowed">
                @if (savingMap[tipo.tipo]) {
                  <i class="pi pi-spin pi-spinner text-xs"></i>
                } @else {
                  <i class="pi pi-plus text-xs"></i>
                }
              </button>
            </div>
          }
        </div>

      </div>
    }

  </div>
</div>
